import axios from 'axios';
import { BASE_URL, DEFAULT_HEADERS } from '../apiConfig';

// دالة للحصول على كل الإحصائيات
export const getStatistics = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/projects/sadan/statistics`, {
      headers: DEFAULT_HEADERS,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching statistics:', error);
    throw error;
  }
};


// import axios from 'axios';
// import { BASE_URL, DEFAULT_HEADERS } from '../apiConfig';

// // تعديل الدالة لتستقبل الـ slug
// export const getStatistics = async (projectSlug) => {
//   try {
//     // استخدمنا الـ template literal ليكون الـ slug متغير
//     const response = await axios.get(`${BASE_URL}/projects/${projectSlug}/statistics`, {
//       headers: DEFAULT_HEADERS,
//     });
//     return response.data;
//   } catch (error) {
//     console.error('Error fetching statistics:', error);
//     throw error;
//   }
// };